// 个人中心-监理页面
const NewProject = () => import('@/pages/personalCenter/supervisePage/newProject.vue')
const DecorationRecord = () => import('@/pages/personalCenter/supervisePage/decorationRecord.vue')
const DecorationRecordUpload = () => import('@/pages/personalCenter/supervisePage/decorationRecordUpload.vue')
const ViewProcess = () => import('@/pages/personalCenter/supervisePage/viewProcess.vue')
const pdfViewProcess = () => import('@/pages/personalCenter/supervisePage/pdfViewProcess.vue')
const PdfProcess = () => import('@/pages/personalCenter/supervisePage/pdfProcess.vue')
const Readcontrast = () => import('@/pages/personalCenter/supervisePage/readcontrast.vue')
const ViewStandard = () => import('@/pages/personalCenter/supervisePage/viewStandard.vue')
const WorkerTeam = () => import('@/pages/personalCenter/supervisePage/workerTeam.vue')
const ViewBudget = () => import('@/pages/personalCenter/supervisePage/viewBudget.vue')
const BudgetDetails = () => import('@/pages/personalCenter/supervisePage/budgetDetails.vue')
const ViewDrawing = () => import('@/pages/personalCenter/supervisePage/viewDrawing.vue')
const ViewContract = () => import('@/pages/personalCenter/supervisePage/viewContract.vue')
const ViewStandardDetails = () => import('@/pages/personalCenter/supervisePage/viewStandardDetails.vue')
const plan = () => import('@/pages/personalCenter/supervisePage/plan.vue')
const personTrafficLights = () => import('@/pages/personalCenter/supervisePage/personTrafficLights.vue')
const ConstructionPlan = () => import('@/pages/personalCenter/supervisePage/constructionPlan.vue')
const constructionPlanNotice = () => import('@/pages/personalCenter/supervisePage/constructionPlanNotice.vue')
const historyNotice = () => import('@/pages/personalCenter/supervisePage/historyNotice.vue')
const constructionYPlan = () => import('@/pages/personalCenter/supervisePage/constructionYPlan.vue')
const editPlan = () => import('@/pages/personalCenter/supervisePage/editPlan.vue')
const acceptance = () => import('@/pages/regulationTheScene/acceptance.vue')

export default [
  {
    path: '/personalCenter/supervisePage/newProject',
    name: '新建项目',
    component: NewProject,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/supervisePage/decorationRecord',
    name: '装修记录',
    component: DecorationRecord,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/supervisePage/decorationRecordUpload',
    name: '装修记录上传',
    component: DecorationRecordUpload,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/supervisePage/viewProcess',
    name: '查看进程',
    component: ViewProcess,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },
  {
    path: '/personalCenter/supervisePage/pdfViewProcess',
    name: '打印pdf',
    component: pdfViewProcess,
    meta: {
      headerShow: false,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },
  {
    path: '/personalCenter/supervisePage/pdfProcess',
    name: '进程详情',
    component: PdfProcess,
    meta: {
      headerShow: false,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },
  {
    path: '/personalCenter/supervisePage/readcontrast',
    name: '整改对比',
    component: Readcontrast,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      backTopShow: true//返回到顶部
    }
  },
  {
    path: '/personalCenter/supervisePage/viewStandard',
    name: '施工标准',
    component: ViewStandard,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      backTopShow: true//返回到顶部
    }
  },
  {
    path: '/personalCenter/supervisePage/viewStandardDetails',
    name: '标准详情',
    component: ViewStandardDetails,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      backTopShow: true//返回到顶部
    }
  },
  {
    path: '/personalCenter/supervisePage/workerTeam',
    name: '工人团队',
    component: WorkerTeam,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/supervisePage/viewBudget',
    name: '查看预算',
    component: ViewBudget,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/supervisePage/budgetDetails',
    name: '预算详情',
    component: BudgetDetails,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/supervisePage/viewDrawing',
    name: '查看图纸',
    component: ViewDrawing,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/supervisePage/viewContract',
    name: '查看合同',
    component: ViewContract,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/supervisePage/plan',
    name: '施工计划',
    component: plan,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/supervisePage/personTrafficLights',
    name: '红绿灯编辑',
    component: personTrafficLights,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/supervisePage/constructionPlan',
    name: '施工计划表',
    component: ConstructionPlan,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },
  {
    path: '/personalCenter/supervisePage/constructionPlanNotice',
    name: '发送通知',
    component: constructionPlanNotice,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },
  {
    path: '/personalCenter/supervisePage/historyNotice',
    name: '历史消息',
    component: historyNotice,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },
  {
    path: '/personalCenter/supervisePage/constructionYPlan',
    name: '原计划表',
    component: constructionYPlan,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },
  {
    path: '/personalCenter/supervisePage/editPlan',
    name: '编辑计划',
    component: editPlan,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },
  {
    path: '/personalCenter/supervisePage/acceptance',
    name: '查看验收项',
    component: acceptance,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },

]



// WEBPACK FOOTER //
// ./src/router/modules/superviseRouter.js